export const getCircleProgress = (value: number, maxValue: number) => {
  if (!value) {
    return 1;
  }
  const calculatedValue = Math.round((value / maxValue) * 100) / 100;
  if (calculatedValue > 1) {
    return 0;
  }

  return 1 - (calculatedValue < 0.1 ? 0.1 : calculatedValue);
};
